<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mail</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-form @submit="doInvite">
        <v-card-title>
          <span
            class="headline"
            v-html="'Invite a user to the unit <strong>' + unitObject.name + '</strong>'"
          ></span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  autofocus
                  type="email"
                  v-model="email"
                  label="E-Mail"
                  required
                  prepend-icon="email"
                  :rules="emailRules"
                ></v-text-field>
                <v-textarea
                  v-model="text"
                  :label="$t('flat-invitation-leave-message')"
                  prepend-icon="message"
                ></v-textarea>
                <transition name="fade">
                  <v-alert :value="error" type="error">{{error}}</v-alert>
                </transition>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="dialog = false">
            <v-icon>close</v-icon>Close
          </v-btn>
          <v-spacer />
          <v-btn flat type="submit">
            <v-icon>mail</v-icon>Invite
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    doInvite(event) {
      event.preventDefault();
      if (!this.validEmail(this.email)) {
        this.error = "Please enter a valid email address";
        return;
      }
      this.error = null;
      this.$store
        .dispatch("duo/flatInvite", {
          flat: this.unitUuid,
          email: this.email,
          attributes: {
            name: this.unitObject.name,
            location: this.unitObject.location,
            note: this.unitObject.note,
            text: this.text,
            language: this.$i18n.locale
          }
        })
        .then(() => {
          this.dialog = false;
        })
        .catch(e => {
          console.log(e.response.data);
          this.error = e.response.data.message || e;
        });
    }
  },
  props: {
    unitObject: Object,
    unitUuid: String
  },

  data() {
    return {
      error: null,
      dialog: false,
      email: "",
      text: "Dear User, Someone what you bind to the gateway.",
      emailRules: [
        v => /.+@.+/.test(v) || v.length == 0 || "Invalid Email address"
      ]
    };
  },
  watch: {
    dialog: function(value) {
      if (!value) {
        this.error = null;
        this.email = "";
      }
    }
  }
};
</script>

<style>
</style>
